import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";
import { loginGuard } from "./guards/auth-login.guard";
import { permissionGuard } from "./guards/permission.guard";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "login" },
  {
    path: "login",
    canMatch: [loginGuard],
    title: "Iniciar sesión - VIRA Vehicle Info",
    loadComponent: () =>
      import("./auth/feature/login-page/login-page.component").then((c) => c.LoginPageComponent),
  },
  {
    path: "reset-password/:token",
    title: "Restablecer contraseña - VIRA Vehicle Info",
    loadComponent: () =>
      import("./auth/feature/reset-password/reset-password.component").then(
        (c) => c.ResetPasswordComponent
      ),
  },
  {
    path: "admin",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./admin/ui/layout/layout.component").then((m) => m.LayoutComponent),
    children: [
      {
        path: "dashboard",
        title: "Dashboard - VIRA Vehicle Info",
        loadComponent: () =>
          import("./dashboard/feature/dashboard/dashboard.component").then(
            (d) => d.DashboardComponent
          ),
      },
      {
        path: "companies",
        canActivate: [permissionGuard(["BETACORE_ADMIN"])],
        title: "Empresas - VIRA Vehicle Info",
        loadComponent: () =>
          import("./companies/feature/company-list/company-list.component").then(
            (c) => c.CompanyListComponent
          ),
      },
      {
        path: "companies/:companyId/users",
        canActivate: [permissionGuard(["BETACORE_ADMIN"])],
        title: "Usuarios - VIRA Vehicle Info",
        loadComponent: () =>
          import("./users/feature/user-list/user-list.component").then((u) => u.UserListComponent),
      },
      {
        path: "companies/:companyId/api-keys",
        canActivate: [permissionGuard(["BETACORE_ADMIN"])],
        title: "API Keys - VIRA Vehicle Info",
        loadComponent: () =>
          import("./api-keys/feature/api-key-list/api-key-list.component").then(
            (a) => a.ApiKeyListComponent
          ),
      },
      {
        path: "companies/:companyId/rules",
        canActivate: [permissionGuard(["BETACORE_ADMIN"])],
        title: "Reglas - VIRA Vehicle Info",
        loadComponent: () =>
          import("./rules/feature/rules-form/rules-form.component").then(
            (r) => r.RulesFormComponent
          ),
      },
      {
        path: "companies/:companyId/usage",
        canActivate: [permissionGuard(["BETACORE_ADMIN"])],
        title: "Consumo - VIRA Vehicle Info",
        loadComponent: () =>
          import("./usage/feature/usage-page/usage-page.component").then(
            (u) => u.UsagePageComponent
          ),
      },
      {
        path: "my-usage",
        canActivate: [permissionGuard(["COMPANY_ADMIN", "COMPANY_MEMBER"])],
        title: "Mi consumo - VIRA Vehicle Info",
        loadComponent: () =>
          import("./usage/feature/usage-page/usage-page.component").then(
            (u) => u.UsagePageComponent
          ),
      },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
  {
    path: "**",
    title: "Página no encontrada - VIRA Vehicle Info",
    loadComponent: () =>
      import("./shared/pages/not-found/not-found.component").then((m) => m.NotFoundComponent),
  },
];
